/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvestmentAccountTickerGetResponseFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type InvestmentAccountTickerGetResponse, type ProblemDetails } from '../../../../models';
// @ts-ignore
import { TransactionsRequestBuilderNavigationMetadata, TransactionsRequestBuilderRequestsMetadata, type TransactionsRequestBuilder } from './transactions';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /investmentaccounts/{investmentAccountId}/tickers/{tickerId}
 */
export interface WithTickerItemRequestBuilder extends BaseRequestBuilder<WithTickerItemRequestBuilder> {
    /**
     * The transactions property
     */
    get transactions(): TransactionsRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvestmentAccountTickerGetResponse>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvestmentAccountTickerGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTickerItemRequestBuilderUriTemplate = "{+baseurl}/investmentaccounts/{investmentAccountId}/tickers/{tickerId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTickerItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTickerItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    transactions: {
        requestsMetadata: TransactionsRequestBuilderRequestsMetadata,
        navigationMetadata: TransactionsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTickerItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithTickerItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithTickerItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvestmentAccountTickerGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
